const texts = {
    "success-page.instructions": {
        EN: "You will receive an email with return instructions.",
        DA: "Du vil modtage en e-mail med returinstruktioner.",
        DE: "Du erhältst in Kürze eine E-Mail mit Rücksendeanweisungen.",
        NL: "Je ontvangt een e-mail met retourinstructies.",
        FR: "Vous recevrez un e-mail avec les instructions de retour.",
        IT: "Riceverai un'e-mail con le istruzioni per il reso.",
        ES: "Recibirás un correo electrónico con instrucciones de devolución.",
        PT: "Você receberá um e-mail com instruções de devolução.",
        FI: "Saat sähköpostin palautusohjeilla.",
        SV: "Du kommer snart att få ett mejl med instruktioner för returleverans.",
        NO: "Du vil snart motta en e-post med instruksjoner for returlevering.",
    },
    "success-page.instructions.withdrawal": {
        EN: "You will receive a confirmation email shortly.",
        DA: "Du vil snart modtage en bekræftelses-e-mail.",
        DE: "Du erhältst in Kürze eine Bestätigungs-E-Mail.",
        NL: "Je ontvangt binnenkort een bevestigingse-mail.",
        FR: "Vous recevrez prochainement un e-mail de confirmation.",
        IT: "Riceverai a breve un'email di conferma.",
        ES: "Recibirás un correo electrónico de confirmación en breve.",
        PT: "Você receberá um e-mail de confirmação em breve.",
        FI: "Saat vahvistussähköpostin pian.",
        SV: "Du kommer snart att få ett bekräftelsemail.",
        NO: "Du vil snart motta en bekreftelses-e-post.",
    },
    "success-page.instructions-claim": {
        EN: "Now you can sit back and relax — our Customer Service will get back to you as soon as possible to address your claim!",
        EN_TR: "Now you can sit back and relax while our Customer Service will get back to you as soon as possible to address your complaint!",
        DA: "Nu kan du læne dig tilbage, så vender vores kundeservice hurtigst muligt tilbage for at behandle din reklamation!",
        DE: "Lehn dich zurück – unser Kundenservice meldet sich so schnell wie möglich, um deine Reklamation zu bearbeiten!",
        NL: "Leun gerust achterover — onze klantenservice neemt zo snel mogelijk contact met je op om je reclamatie te behandelen!",
        FR: "Vous pouvez vous détendre — notre service client vous recontactera au plus vite pour traiter votre réclamation !",
        IT: "Puoi rilassarti: il nostro servizio clienti ti contatterà al più presto per gestire il tuo reclamo!",
        ES: "Puedes relajarte: nuestro servicio de atención al cliente se pondrá en contacto contigo lo antes posible para atender tu reclamación.",
        PT: "Agora é só relaxar — nosso atendimento entrará em contato o mais breve possível para tratar sua reclamação!",
        FI: "Voit nyt rauhassa odotella — asiakaspalvelumme ottaa sinuun yhteyttä mahdollisimman pian käsitelläkseen valituksesi!",
        SV: "Nu kan du luta dig tillbaka — vår kundtjänst återkommer så snart som möjligt angående din reklamation!",
        NO: "Du kan slappe av — kundeservicen vår tar kontakt så snart som mulig for å behandle klagen din!",
    },
    "success-page.instructions-resale": {
        EN: "You will soon b{receive an email} with instructions.",
        DA: "Du vil snart b{modtage en e-mail} med instruktioner.",
        DE: "Du wirst bald b{eine E-Mail erhalten} mit Anweisungen.",
        NL: "Binnenkort b{ontvang je een e-mail} med instruktioner.",
        FR: "Vous allez bientôt b{recevoir un e-mail} avec des instructions.",
        IT: "Riceverai presto b{un'e-mail} con le istruzioni.",
        ES: "Pronto b{recibirás un correo electrónico} con instrucciones.",
        PT: "Em breve você b{receberá um e-mail} com instruções.",
        FI: "Saat pian b{sähköpostin} ohjeilla.",
        SV: "Du kommer snart att b{få ett mejl} med instruktioner.",
        NO: "Du vil snart b{motta en e-post} med instruksjoner.",
    },
    "success-page.instructions-end": {
        EN: "Thank you for taking responsibility and helping the environment by reducing transport and emissions.",
        DA: "Tak for at tage ansvar og hjælpe miljøet ved at reducere transport og udledninger.",
        DE: "Danke, dass Sie Verantwortung übernehmen und der Umwelt helfen, indem Sie Transporte und Emissionen reduzieren.",
        NL: "Bedankt voor het nemen van verantwoordelijkheid en het helpen van het milieu door transport en uitstoot te verminderen.",
        FR: "Merci de prendre vos responsabilités et d'aider l'environnement en réduisant les transports et les émissions.",
        IT: "Grazie per assumerti la responsabilità e aiutare l'ambiente riducendo i trasporti e le emissioni.",
        ES: "Gracias por asumir la responsabilidad y ayudar al medio ambiente reduciendo el transporte y las emisiones.",
        PT: "Obrigado por assumir a responsabilidade e ajudar o meio ambiente reduzindo transportes e emissões.",
        FI: "Kiitos että otat vastuuta ja autat ympäristöä vähentämällä kuljetuksia ja päästöjä.",
        SV: "Tack för att du tar ansvar och hjälper miljön att minska transporter och utsläpp.",
        NO: "Bærekraft er viktig for oss! Takk for at du tar ansvar og hjelper miljøet med å redusere transporter og utslipp.",
    },
    "success-page.printing-label-intro": {
        EN: "Press the button below to start printing your return label.",
        DA: "Tryk på knappen nedenfor for at begynde at udskrive din returetiket",
        DE: "Drücken Sie die Schaltfläche unten, um mit dem Drucken Ihres Rücksendeetiketts zu beginnen",
        NL: "Klik op de knop hieronder om je retouretiket te printen.",
        FR: "Appuyez sur le bouton ci-dessous pour commencer à imprimer votre étiquette de retour",
        IT: "Premi il pulsante qui sotto per iniziare a stampare la tua etichetta di reso",
        ES: "Presiona el botón a continuación para comenzar a imprimir tu etiqueta de devolución",
        PT: "Pressione o botão abaixo para começar a imprimir sua etiqueta de devolução",
        FI: "Paina alla olevaa painiketta tulostaaksesi palautustarran.",
        SV: "Klicka på knappen nedan för att börja skriva ut din returetikett.",
        NO: "Klikk på knappen nedenfor for å skrive ut returetiketten.",
    },
    "success-page-printing-label-outro": {
        EN: "to open your return instructions.<br/>You will also receive an email with the same instructions.",
        DA: "for at åbne dine returinstruktioner.<br/>Du modtager også en e-mail med de samme instruktioner.",
        DE: "um deine Rücksendeanweisungen at åbne.<br/>Du erhältst også eine E-Mail med samme instruktioner.",
        NL: "för att öppna dina returinstruktioner.<br/>Je ontvangt ook een e-mail med samma instruktioner.",
        FR: "pour afficher vos instructions de retour.<br/>Vous recevrez également un e-mail avec les mêmes instructions.",
        IT: "per aprire le istruzioni di reso.<br/>Riceverai anche un'e-mail con le stesse istruzioni.",
        ES: "para ver tus instrucciones de devolución.<br/>También recibirás un correo con las mismas instrucciones.",
        PT: "para abrir suas instruções de devolução.<br/>Você também receberá um e-mail com as mesmas instruções.",
        FI: "avata palautusohjeet.<br/>Saat samat ohjeet myös sähköpostitse.",
        SV: "för att öppna dina returinstruktioner.<br/>Du får även ett mejl med samma instruktioner.",
        NO: "for å åpne returinstruksjonene dine.<br/>Du får også en e-post med de samme instruksjonene.",
    },
    "success-page.exchange-payment": {
        EN: "Please speed things up by b{proceeding with the payment} for the exchange fee.",
        DA: "Hjælp os med at fremskynde processen ved at b{fortsætte til betaling} af byttegebyret.",
        DE: "Beschleunige processen ved at b{fortsætte til betaling} af byttegebyret.",
        NL: "Versnel het proces door b{door te gaan naar de betaling} van de omruilkosten.",
        FR: "Accélérez le processus en b{procédant au paiement} des frais d'échange.",
        IT: "Accelera la procedura b{procedendo al pagamento} del costo di cambio.",
        ES: "Acelera el proceso b{continuando con el pago} de la tarifa de cambio.",
        PT: "Agilize o processo b{prosseguindo com o pagamento} da taxa de troca.",
        FI: "Nopeuta prosessia b{siirtymällä maksamaan} vaihdon maksun.",
        SV: "Hjälp oss att skynda på genom att b{fortsätta till betalning} av bytesavgiften.",
        NO: "Hjelp oss å få fortgang ved å b{fortsette til betaling} av byttegebyret.",
    },
    "success-page.exchange-button": {
        EN: "Proceed with payment",
        DA: "Fortsæt med betaling",
        DE: "Zur Zahlung fortfahren",
        NL: "Verder naar betaling",
        FR: "Procéder au paiement",
        IT: "Procedi con il pagamento",
        ES: "Proceder con el pago",
        PT: "Prosseguir com o pagamento",
        FI: "Siirry maksuun",
        SV: "Fortsätt till betalning",
        NO: "Fortsett til betaling",
    },
};
export default texts;
